module.exports = __webpack_public_path__ + "@/assets/img/banner-mp-mobile.580a5725.png";